<template>
  <div id="search-box">
    <el-row>
      <el-col :span="4" style="padding: 0 5px;" >
        <label class="label-form-search">{{$t('startDate')}}</label><br>
        <el-date-picker v-model="filter.startDate" style="width: 100% !important;"
                        type="date"
                        format="d MMM yyyy"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('selectDate')"
                        size="mini">
        </el-date-picker>
      </el-col>
      <el-col :span="4" style="padding: 0 5px;" >
        <label class="label-form-search">{{$t('endDate')}}</label><br>
        <el-date-picker v-model="filter.endDate" style="width: 100% !important;"
                        type="date"
                        format="d MMM yyyy"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('selectDate')"
                        size="mini">
        </el-date-picker>
      </el-col>
      <el-col :span="4" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('hotel')}}</label>
        <el-select v-model="filter.hotelId"
                   :placeholder="$t('all')"
                   size="mini"
                   filterable>
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            v-for="(hotel, index) in sortedHotelList"
            :key="index"
            :label="hotel.name"
            :value="hotel.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('emailType')}}</label>
        <el-select v-model="filter.sendType" :placeholder="$t('all')" size="mini">
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            :label="$t('general')"
            :value="EMAIL_SEND_TYPE.GENERAL">
          </el-option>
          <el-option
            :label="$t('stopSale')"
            :value="EMAIL_SEND_TYPE.STOP_SALE">
          </el-option>
          <el-option
            :label="$t('contract')"
            :value="EMAIL_SEND_TYPE.CONTRACT">
          </el-option>
          <el-option
            :label="$t('specialOffer')"
            :value="EMAIL_SEND_TYPE.SPECIAL_OFFER">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <br />
        <el-button-group size="mini">
          <el-button type="primary"
                     size="mini"
                     @click="onSearchButtonClick">
            {{ $t('search') }}
          </el-button>
          <el-button type="info"
                     size="mini"
                     @click="onResetButtonClick">
            {{ $t('reset') }}
          </el-button>
        </el-button-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { EMAIL_SEND_TYPE } from '@/configs/constant'
import i18nMessages from '@/translations/Email/ManageEmail/EmailHistory/Index.i18n'

export default {
  name: 'EmailHistorySearchComponent',
  i18n: { messages: i18nMessages },
  props: {
    hotelList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created: function () {
    this.sortedHotelList = this.hotelList.sort((a, b) => {
      return (a.name > b.name) ? 1 : -1
    })
  },
  data () {
    return {
      EMAIL_SEND_TYPE,
      filter: {
        startDate: '',
        endDate: '',
        hotelId: '',
        sendType: ''
      },
      sortedHotelList: []
    }
  },
  methods: {
    onSearchButtonClick: async function () {
      if (this.filter.startDate === null) {
        this.filter.startDate = ''
      }

      if (this.filter.endDate === null) {
        this.filter.endDate = ''
      }

      this.$emit('onSearchButtonClick', this.filter)
    },
    onResetButtonClick: async function () {
      this._resetFilter()

      this.$emit('onResetButtonClick', this.filter)
    },
    _resetFilter: function () {
      this.filter.startDate = ''
      this.filter.endDate = ''
      this.filter.hotelId = ''
      this.filter.sendType = ''
    }
  }
}
</script>

<style scoped>
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 177px;
  }
  .el-select {
    width: 100%;
  }
  .label-form-search {
    font-size: 13px;
    font-weight: 100;
  }
  #search-box{
    margin: 20px 0;
    padding: 15px 20px;
    background: #eeeeee;
    border: solid 1px #d8d6d6;
    border-radius: 5px;
  }
</style>
